import React, { useState } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import { FormGroup, Input, Label, ModalBody } from 'reactstrap';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import useForm from '../CustomHooks/useForm';
import basePCUrl from '../../../Globals';

const useModalStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 12,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
      minWidth: 500,
    },
  },
  dialogTitle: {
    background: 'linear-gradient(135deg, #0a1e42 0%, #0b5fad 50%, #3a8ac4 100%)',
    color: 'white',
    padding: '16px 24px',
    textAlign: 'center',
    margin: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
  modalBody: {
    padding: theme.spacing(4),
  },
  title: {
    textAlign: 'center',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
    color: '#061739',
    marginBottom: theme.spacing(3),
  },
  userInfo: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    background: 'rgba(0, 85, 162, 0.05)',
    borderRadius: 8,
    fontWeight: 600,
  },
  radioGroup: {
    display: 'flex',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    background: 'rgba(255, 255, 255, 0.6)',
    borderRadius: 8,
  },
  submitButton: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: '0.9rem',
    textTransform: 'none',
    marginTop: theme.spacing(2),
    backgroundColor: '#0055A2',
    color: '#fff',
    padding: theme.spacing(1.5),
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#003d75',
      boxShadow: 'none',
    },
  },
}));

const EditUserModal = (props) => {
  const modalClasses = useModalStyles();
  const [isLoading, setLoading] = useState();
  const [error, setError] = useState();
  const { getAccessTokenSilently } = usePortalAuth();

  const { values: newAccessLevel, bind: bindNewAccessLevel, reset: resetNewAccessLevel } = useForm('');

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  const displayUserForEdit = () => {
    return <h5>{getTranslation('Editing User', preferredLanguage)}: {props.selected}</h5>;
  };

  const handleNewAccessLevelClick = (event) => {
    event.preventDefault();
    editUserAccessLevel(props.usersForEdit);
    props.toggle();
    resetNewAccessLevel();
  };


  const editUserAccessLevel = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();

    var data = {
      email: props.selected,
      accessLevel: newAccessLevel,
    };

    fetch(basePCUrl + 'UserManagement/ModifyUserSettings', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }

        response.json().then((data) => {
          if (data.accessLevel === 'Error') {
            setError(true);
            console.log('There was an error while editing this user');
            setLoading(false);
          } else {
            props.retrieveUsers();
            props.resetSelected([]);
            setLoading(false);
          }
        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  };

  const DialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={modalClasses.dialogTitle} style={{ position: 'relative' }} {...other}>
        <Typography variant="h6" style={{ color: 'white', fontFamily: 'Montserrat, sans-serif', fontWeight: 700 }}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton aria-label="close" className={modalClasses.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  return (
    <Dialog
      className={modalClasses.dialog}
      onClose={props.toggle}
      aria-labelledby="customized-dialog-title"
      open={props.isOpen}
    >
      <DialogTitle id="customized-dialog-title" onClose={props.toggle}>
        {getTranslation('Edit User Access Level', preferredLanguage)}
      </DialogTitle>

      <div className={modalClasses.modalBody}>

        <Typography className={modalClasses.userInfo}>
          {getTranslation('Editing User', preferredLanguage)}: <strong>{props.selected}</strong>
        </Typography>

        <FormGroup className={modalClasses.radioGroup}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <Input
              type="radio"
              id="accessLevelUser"
              name="accessLevel"
              checked={newAccessLevel === 'User'}
              {...bindNewAccessLevel}
              value="User"
              style={{ cursor: 'pointer' }}
            />
            <span>{getTranslation('User', preferredLanguage)}</span>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <Input
              type="radio"
              id="accessLevelAdmin"
              name="accesLevel"
              {...bindNewAccessLevel}
              value="CompanyAdmin"
              checked={newAccessLevel === 'CompanyAdmin'}
              style={{ cursor: 'pointer' }}
            />
            <span>{getTranslation('Company Admin', preferredLanguage)}</span>
          </label>
        </FormGroup>

        <Button
          fullWidth
          onClick={handleNewAccessLevelClick}
          id="editSelectedEmail"
          className={modalClasses.submitButton}
        >
          {getTranslation('Edit', preferredLanguage)}
        </Button>
      </div>
    </Dialog>
  );
};
export default EditUserModal;
